import React from 'react';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography/index.js';
import { buildElementStyling } from '../utils';
import { RichTextNode } from '../types';

const RichTextH5 = ({ children, value }: RichTextNode) => {
  const { className, style } = buildElementStyling({ baseClass: 'richTextH3', value });
  return (
    <Typography element="h5" className={className} style={style}>
      {children}
    </Typography>
  );
};

RichTextH5.displayName = 'RichTextH5';

export default RichTextH5;
